import { StyledContainer as Container } from './Container.styled';

export default Container;
